// useSidebarFilters.ts
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setFilterResult } from "../../store/slices/filterSlice";
import { useGetRefData } from "../../containers/records/useGetRefData.hook";

export const useSidebarFilters = (selectedFilter: any) => {
  const dispatch = useDispatch();
  const [localFilter, setLocalFilter] = useState(selectedFilter);

  // Sync local filter with selected filter prop
  useEffect(() => {
    setLocalFilter(selectedFilter);
  }, [selectedFilter]);

  const applyFilters = () => {
    dispatch(setFilterResult(localFilter));
  };

  const { options } = useGetRefData(localFilter.selectedRegions);

  const {
    distinctRegions,
    countryNames,
    affiliateNames,
    risks: { riskLabels, riskValues },
    distinctEvaluations,
    distinctStatus,
    distinctProducts,
    distinctSampleId,
    distinctFieldNames,
    validAffiliates,
  } = options;

  useEffect(() => {
    setLocalFilter((prev: any) => {
      return {
        ...prev,
        selectedAffiliates: validAffiliates(
          prev.selectedAffiliates,
          prev.selectedRegions,
        ),

        selectedCountries: validAffiliates(
          prev.selectedCountries,
          prev.selectedRegions,
        ),
      };
    });
  }, [localFilter.selectedRegions, validAffiliates]);

  return {
    localFilter,
    setLocalFilter,
    applyFilters,
    distinctRegions,
    countryNames,
    affiliateNames,
    risks: { riskLabels, riskValues },
    distinctEvaluations,
    distinctStatus,
    distinctProducts,
    distinctSampleId,
    distinctFieldNames,
  };
};
